import { sendEmailVerification } from 'firebase/auth';
import { auth } from '../config/firebase';
import { sendVerificationEmailViaApi } from '../services/authApi';

export const getFrontendUrl = () => {
  const fromEnv = process.env.REACT_APP_FRONTEND_URL;
  if (fromEnv) return fromEnv.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return 'https://hakacompany.com.br';
};

export const getEmailActionSettings = () => ({
  url: getFrontendUrl(),
  handleCodeInApp: false,
});

export const applyAuthEmailLanguage = () => {
  auth.languageCode = 'pt';
};

const sendViaFirebase = async (user) => {
  try {
    await sendEmailVerification(user);
    return true;
  } catch (err) {
    console.error('Erro ao enviar email de verificação (Firebase):', err);
    return false;
  }
};

export const sendVerificationEmail = async (user, idToken) => {
  applyAuthEmailLanguage();

  if (idToken) {
    try {
      await sendVerificationEmailViaApi(idToken);
      return true;
    } catch (err) {
      console.warn('Falha ao enviar verificação via Resend, tentando Firebase:', err);
    }
  }

  return sendViaFirebase(user);
};
